import { useParams } from "react-router-dom";
import { declinePhysicianInviteApi, getPhysicianInviteApi } from "@/portals/physician/api/physicianAuthApi";
import type { InvitePreview } from "@/portals/physician/api/types";
import { DeclineInviteScreen } from "@/shared/components/DeclineInviteScreen";

/**
 * /physician/invite/:token/decline — reached from the "Not interested? Decline
 * this invitation" link in the physician invite email. Same flow as the
 * caregiver decline page (see DeclineInviteScreen); the admin who sent the
 * invitation is notified.
 */
export function PhysicianDeclineInvitePage() {
  const { token } = useParams<{ token: string }>();
  return (
    <DeclineInviteScreen<InvitePreview>
      token={token}
      loadPreview={async (t) => (await getPhysicianInviteApi(t)).data}
      decline={async (t) => {
        const { error } = await declinePhysicianInviteApi(t);
        return error ? error.message : null;
      }}
      confirmIcon="lucide:stethoscope"
      description={(preview) => (
        <>
          <span className="font-semibold text-[#374151]">{preview.email}</span> was invited to join MedSyncIQ as a
          reviewing physician. You can decline without creating an account.
        </>
      )}
      declinedMessage={() => "The MedSyncIQ team has been notified that you won't be accepting this invitation."}
      invalidMessage="This invitation may have already been accepted, declined, cancelled or expired, or the link is incorrect."
      signInPath="/physician/login"
    />
  );
}
